/**
 * Created by DejanK on 1/20/2017.
 */
import { noop, get } from 'lodash'
import './hotel-profile.scss'
import HTML from './hotel-profile.html'
import PHOTO_NOT_AVAILABLE from 'images/ui/no-hotel-photo-available.gif'

const NAME = 'destinationManagerHotelProfile'
export { NAME, HTML, DestinationsManagerHotelProfileController as Controller }

DestinationsManagerHotelProfileController.$inject = ['NotificationUtils', 'SupplierHotelId', 'DataServer', 'TravelDestinationManagerService', 'rbDialog', '$stateParams']
function DestinationsManagerHotelProfileController(utils, SupplierHotelId, dataServer, ManagerService, dialog, stateParams){
  const vm = this

  vm.cancel = dialog.cancel;
  vm.addToBidManager = addToBidManager;
  vm.removeFromBidManager = removeFromBidManager;

  $onInit();

  function $onInit(){
    vm.rfpId = stateParams.rfpId
    vm.destinationId = stateParams.destinationId
    vm.supplier = ManagerService.getSupplierByHotelId(SupplierHotelId);
    vm.supplierImageUrl = get(vm.supplier, 'image.url', PHOTO_NOT_AVAILABLE)
    utils.onLoad( () => dataServer.getAmenities(), vm, 'amenities' ).catch( noop )
    ManagerService.scrollListTo(vm.supplier.id);
  }

  function addToBidManager(){
    ManagerService.addToTheBidManager(vm.rfpId, vm.destinationId, vm.supplier);
    dialog.cancel().catch(noop)
  }

  function removeFromBidManager(){
    ManagerService.removeFromBidManager(vm.rfpId, vm.destinationId, vm.supplier);
    dialog.cancel().catch(noop)
  }
}
